'use client'

interface AvatarDisplayProps {
  avatarId: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
  name?: string
  colorClassName?: string
}

export function AvatarDisplay({ avatarId, size = 'md', className = '', name = 'U', colorClassName }: AvatarDisplayProps) {
  const sizeClasses = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
  }

  // Get first letter of name or default to 'U'
  const initial = name?.charAt(0).toUpperCase() || 'U'
  
  // Generate a consistent color based on the avatarId or name
  const colors = [
    'bg-blue-500', 'bg-green-500', 'bg-yellow-500', 'bg-red-500', 
    'bg-purple-500', 'bg-pink-500', 'bg-indigo-500', 'bg-teal-500'
  ]
  const colorIndex = (avatarId || name || '').split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length
  const bgColor = colorClassName || colors[colorIndex]

  return (
    <div
      className={`${sizeClasses[size]} ${bgColor} rounded-full flex items-center justify-center text-white font-medium ${className}`}
    >
      {initial}
    </div>
  )
}
